import romanApi, { type RomanApiError } from "@roman/shared/lib/net/romanApi";
import { useEffect } from "react";
import useSWR from "swr";
import { type AuthHeader, useAuthHeader } from "./useAuthHeader";

type UsedReferral = {
  code: string;
  referrer: string;
  usedAt: number;
  earnedPoints: string;
};

const fetcher = (url: string, headers: AuthHeader) => romanApi.get<UsedReferral>(`${url}`, undefined, { headers });

export const useUsedReferral = (handleError: (err: RomanApiError) => void) => {
  const header = useAuthHeader();
  const { data, error, mutate } = useSWR("/referral/used", (url: string) => fetcher(url, header));

  useEffect(() => {
    if (error) {
      handleError(error);
    }
  }, [error, handleError]);

  return {
    data,
    error,
    mutate,
  };
};
